'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Request = function (_React$Component) {
  _inherits(Request, _React$Component);

  function Request(props) {
    _classCallCheck(this, Request);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Request).call(this, props));

    _this.request = null;
    _this.state = {
      error: null,
      result: null,
      loading: true
    };
    return _this;
  }

  _createClass(Request, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.performRequest(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(this.props) === JSON.stringify(nextProps)) {
        return;
      }

      this.request.abort();
      this.performRequest(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.request.abort();
    }
  }, {
    key: 'performRequest',
    value: function performRequest(props) {
      var _this2 = this;

      var method = props.method;

      if (method === 'delete') {
        method = 'del';
      }

      this.request = _superagent2.default[method](props.url);

      if (props.headers) {
        this.request.set(props.headers);
      }

      if (props.withCredentials) {
        this.request.withCredentials();
      }

      if (props.buffer) {
        this.request.buffer();
      }

      var auth = props.auth;

      if (auth) {
        this.request.auth(auth.user, auth.pass);
      }
      if (props.fields) {
        for (var i = 0; i < props.fields.length; i++) {
          if (props.fields[i]) {
            this.request.field(props.fields[i].name, props.fields[i].value);
          }
        }
      }
      if (props.attach) {
        for (var i = 0; i < props.attach.length; i++) {
          if (props.attach[i]) {
            this.request.attach(props.attach[i].name, props.attach[i].path, props.attach[i].filename);
          }
        }
      }

      var configs = ['type', 'accept', 'send', 'query', 'timeout', 'redirects'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = configs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (props[i]) {
            this.request[i](props[i]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (props.onRequest) {
        this.request = props.onRequest(this.request);
      }

      this.request.end(function (error, result) {
        if (error || !result.ok) {
          _this2.printLog(props, error);
        } else {
          _this2.printLog(props, result);
        }
        _this2.setState({
          error: error,
          result: result,
          loading: false
        });
      });
    }
  }, {
    key: 'printLog',
    value: function printLog(props, res) {
      if (props.verbose && res) {
        console.log(res);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.state);
    }
  }]);

  return Request;
}(_react2.default.Component);

Request.defaultProps = {
  method: 'get'
};


Request.propTypes = {
  children: _react2.default.PropTypes.func,
  method: _react2.default.PropTypes.string.isRequired,
  type: _react2.default.PropTypes.string,
  accept: _react2.default.PropTypes.string,
  url: _react2.default.PropTypes.string.isRequired,
  timeout: _react2.default.PropTypes.number,
  verbose: _react2.default.PropTypes.bool,
  query: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
  send: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
  headers: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  withCredentials: _react2.default.PropTypes.bool,
  buffer: _react2.default.PropTypes.bool,
  attach: _react2.default.PropTypes.array,
  fields: _react2.default.PropTypes.array,
  onRequest: _react2.default.PropTypes.func
};

exports.default = Request;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-http-request/lib/index.js
 ** module id = 1903
 ** module chunks = 0
 **/